import type React from 'react'

import { PublishButton, Share } from './components'
import css from './styles.module.css'
import { useShareAndPublish } from './useShareAndPublish'

export const ShareAndPublish: React.FC = () => {
  const { showShare, showPublish } = useShareAndPublish()

  if (!showShare || !showPublish) {
    return null
  }

  return (
    <div className={css.share_publish}>
      {showShare && <Share />}

      {showPublish && (
        <PublishButton hasShare={showShare} dividerClassName={css.divider} />
      )}
    </div>
  )
}
